import Vue from 'vue'
import App from './App.vue';
import { Icon } from 'leaflet';
import '@/assets/css/tailwind.css';
import 'leaflet/dist/leaflet.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueToast from 'vue-toast-notification';
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import VModal from 'vue-js-modal';
import VueCryptojs from 'vue-cryptojs';
import VueQrcodeReader from "vue-qrcode-reader";
import VueSocketIOExt from 'vue-socket.io-extended';
import SocketIO from 'socket.io-client';
import IdleVue from "idle-vue";
import { Datetime } from 'vue-datetime';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css';
import VueAnalytics from 'vue-analytics';

import router from './router';
import store from './store';
import './registerServiceWorker'
import { install } from 'vuex';

const eventsHub = new Vue();

Vue.config.productionTip = false

Vue.use(VueAxios, axios);
Vue.use(VueToast);
// Vue.use(VModal);
Vue.use(VModal, { dialog: true })
Vue.use(VueCryptojs);
Vue.use(VueQrcodeReader);
// Vue.use(VueSocketIO, SocketInstance)
Vue.use(VueSocketIOExt, SocketIO(process.env.VUE_APP_NODE_URL));
Vue.use(Datetime)
Vue.component("v-select", vSelect);

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 300000, // 5 minutes,
  startAtIdle: false
});

const MyPlugin = 
  {install (Vue, data) {

    Vue.prototype.encrypt = function (data) {
      //console.log(data)
      const ndata = data || "";
      return(Vue.CryptoJS.AES.encrypt(ndata.toString(), process.env.VUE_APP_SECRET_QR_PASSWORD).toString());
    }

  
    Vue.prototype.decrypt = function (data) {
      if (data!=null){
        return(Vue.CryptoJS.AES.decrypt(data, process.env.VUE_APP_SECRET_QR_PASSWORD).toString(Vue.CryptoJS.enc.Utf8));
      }
      else{
        return(null);
      }
    }
    
  }  
};

Vue.use(MyPlugin);

// Vue.use(VueAnalytics, {
//   id: 'UA-12345678-1',
//   router
// });

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

// export const eventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



